var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcImproveSignupExperience(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 584,
    height: 506,
    viewBox: "0 0 584 506",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.781 427.863C249.76 345.161 240.194 184.341 154.105 202.675C68.0152 221.009 64.4281 324.569 73.3958 374.057C81.367 402.953 127.002 389.601 90.3346 296.338",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4425 286.372C36.1966 285.708 -20.4268 310.88 13.6114 395.977C57.4531 505.583 282.641 568.354 348.404 395.977",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M407.191 343.168C390.253 323.24 371.321 343.168 353.385 323.24V373.5C356.574 381.471 364.063 373.5 368.332 370.071L407.191 343.168Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M444.058 316.265L361.292 375.384C357.982 377.748 353.385 375.382 353.385 371.315V262.459",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M394.238 239.542L459.004 109.013",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M492.882 111.006L419.148 261.463",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M516.796 140.898L453.026 269.435",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M434.095 97.0566L356.351 255.496C355.972 256.268 356.679 257.142 357.52 256.964C370.018 254.319 391.422 255.713 393.15 279.575C393.207 280.359 394.089 280.833 394.76 280.425C405.765 273.735 424.616 268.886 424.208 296.029C424.195 296.901 425.223 297.437 425.92 296.912C435.657 289.566 451.723 283.263 452.972 305.687C453.032 306.759 454.574 307.136 455.047 306.172L535.728 141.895",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M525.764 4.3905C492.284 -1.18937 476.608 11.3653 472.954 18.3402L452.807 57.6752C452.459 58.355 452.95 59.1608 453.713 59.1463C481.17 58.627 537.288 68.8195 554.777 106.991C555.134 107.771 556.255 107.815 556.638 107.048L561.634 97.0562L581.388 56.5602C581.5 56.3311 581.524 56.0782 581.446 55.8354C576.624 40.7499 558.97 9.92496 525.764 4.3905Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M554.659 110.009L539.058 139.377C538.614 140.212 537.319 140.047 537.055 139.139C531.756 120.912 505.413 88.381 440.668 87.1165C439.937 87.1022 439.439 86.3365 439.755 85.6771L451.033 62.1816",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M457.012 75.1355C470.629 73.1428 505.636 76.7301 536.724 107.02",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcImproveSignupExperience);
export default __webpack_public_path__ + "static/media/oc-improve-signup-experience.f7fd67aaf2324c999d99d3c50f630372.svg";
export { ForwardRef as ReactComponent };